import { defaultConfig } from './const';
import { getRequestData, handleError, handleNotInitializedError, sendCollectRequest, } from './helpers';
/** 埋点SDK */
class CollectSDK {
    static config = defaultConfig;
    static isInitialized = false;
    static collectQueue = [];
    static sendTimer = null;
    /** 埋点初始化 */
    static init(config) {
        if (this.isInitialized) {
            handleError(null, 'already initialized', this.config);
            return;
        }
        this.config = { ...this.config, ...config };
        this.isInitialized = true;
        window.addEventListener('beforeunload', () => {
            if (this.sendTimer) {
                clearTimeout(this.sendTimer);
                this.sendTimer = null;
            }
            if (this.collectQueue.length > 0) {
                sendCollectRequest(this.collectQueue, this.config);
                this.collectQueue = [];
            }
        });
    }
    /** 设置配置 */
    static setConfig(key, value) {
        if (!this.isInitialized) {
            handleNotInitializedError(this.config);
            return;
        }
        this.config[key] = value;
    }
    /** 获取队列中的数据 */
    static getBatchData() {
        const size = Math.min(this.collectQueue.length, this.config.batchSize);
        const batchData = this.collectQueue.slice(0, size);
        this.collectQueue = this.collectQueue.slice(size);
        return batchData;
    }
    /** 处理批量埋点 */
    static processBatchQueue() {
        const batchData = this.getBatchData();
        if (batchData.length > 0) {
            sendCollectRequest(batchData, this.config);
        }
        if (this.collectQueue.length >= this.config.batchSize) {
            // 超出预设阈值，继续处理
            this.processBatchQueue();
        }
    }
    /** 处理埋点请求 */
    static handleCollectRequest(data) {
        if (!this.config.enableBatch) {
            // 不开启批量发送
            sendCollectRequest(data, this.config);
            return;
        }
        this.collectQueue.push(data);
        if (this.collectQueue.length >= this.config.batchSize) {
            this.processBatchQueue();
            return;
        }
        if (!this.sendTimer) {
            this.sendTimer = window.setTimeout(() => {
                this.processBatchQueue();
                this.sendTimer = null;
            }, this.config.batchSendInterval);
        }
    }
    /** 埋点上报 */
    static collect(eventName, customProperties = {}) {
        if (!this.isInitialized) {
            handleNotInitializedError(this.config);
            return;
        }
        const data = getRequestData(eventName, customProperties, this.config);
        this.handleCollectRequest(data);
    }
    /** 手动发送当前队列中的埋点数据 */
    static flush() {
        if (!this.isInitialized) {
            handleNotInitializedError(this.config);
            return;
        }
        if (this.collectQueue.length > 0) {
            this.processBatchQueue();
        }
    }
}
export function collect(...args) {
    return CollectSDK.collect(...args);
}
export const flush = () => CollectSDK.flush();
export default CollectSDK;
